// install (please make sure versions match peerDependencies)
// yarn add @nivo/core @nivo/pie
import React from "react";
import { ResponsivePie } from "@nivo/pie";
import { CardContent, Card, CardHeader, Divider } from "@mui/material";
import { Box } from "@mui/system";
// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.
export default function PieChart({ data }) {
  return (
    <Card>
      <CardHeader title="Applicant Sources" />
      <Divider />
      <CardContent>
        <Box
          sx={{
            height: 300,
            position: "relative",
          }}
        >
          <ResponsivePie
            data={data}
            margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
            sortByValue={true}
            padAngle={0.7}
            cornerRadius={2}
            activeOuterRadiusOffset={8}
            borderWidth={1}
            colors={{ scheme: "paired" }}
            borderColor={{
              from: "color",
              modifiers: [["darker", 0.2]],
            }}
            arcLinkLabelsSkipAngle={10}
            arcLinkLabelsTextColor="#333333"
            arcLinkLabelsThickness={2}
            arcLinkLabelsColor={{ from: "color", modifiers: [] }}
            arcLabelsSkipAngle={10}
            // isInteractive={false}
            arcLabelsTextColor={{
              from: "color",
              modifiers: [["darker", 2]],
            }}
            legends={[]}
          />
        </Box>
      </CardContent>
    </Card>
  );
}
